
import Test from "./test"







export default function Deen({test,g}){


console.log(g)
    return(
        <>
        <Test test={test} g={g}/>        
        </>
    )
}